module.exports = __webpack_public_path__ + "img/Metric.e12fced2.png";